(function () {
  "use strict";

  angular
    .module("alk.cloud", ["alk.maps"]);

  angular
    .module("alk.cloud")
    .directive("alkCloudMenu", alkCloudMenu);

  function alkCloudMenu() {

    var directive = {
      bindToController: true,
      controller: cloudMenuController,
      controllerAs: "vm",
      template: require("./alkCloudMenu.html"),
      link: link,
      restrict: "E",
      scope: {
        onAppChange: "&",
        onLogOut: "&",
        hideChangePassword: "@"
      }
    };
    return directive;

    function link(scope, element, attrs) {}
  }

  cloudMenuController.$inject = [
    "$translate",
    "$http",
    "$window",
    "alkAuthenticationService",
    "alkModalService",
    "savedMapInfo",
    "UserProvider",
    "pcmtidLoginService"
  ];

  function cloudMenuController($translate, $http, $window, alkAuthenticationService, alkModalService, savedMapInfo, UserProvider, pcmtidLoginService) {

    var vm = this;
    vm.webToolsImgSrc = "/img/webtools-icon.svg";

    // get licensed products from server
    alkAuthenticationService.getLicensedApps().then((data) => {
      // "[Temporarily] remove RouteReporter and MapExact products for EU accounts in ALK Cloud menu" SWMI-1173
      if (UserProvider.getUser().region === "EU") {
        data.unlicensed = data.unlicensed
          .filter(app => (app.productTitle !== "RouteReporter") && (app.productTitle !== "MapExact"));
      }
      vm.alkCloudProducts = data;
    });

    vm.toggleUnlicensedProductInfo = toggleUnlicensedProductInfo;
    vm.goToInfoPage = goToInfoPage;
    vm.goToAppPage = goToAppPage;
    vm.logout = logout;
    vm.showChangePassword = showChangePassword;
    vm.isOpen = false;

    function toggleUnlicensedProductInfo(product) {
      product.showUnlicensedMessage = !product.showUnlicensedMessage;
    }

    function goToAppPage(product) {
      if (ALK_PRODUCT === product.productTitle)
        return;

      vm.onAppChange({ product });

      let url = product.productAppUrl;
      let centerParams = savedMapInfo.getSavedInfoAsUrl();
      let urlWithCenter = `${url}?center=${centerParams}`;
      vm.isOpen = false;
      $window.open(urlWithCenter, "_self");
    }

    function goToInfoPage(product) {
      vm.isOpen = false;
      $window.open(product.productInfoUrl, "_self");
    }

    function logout() {
     var checklogout = vm.onLogOut();
      if(checklogout){
      alkAuthenticationService.logout().then(() => {
        var idToken = sessionStorage["trimbleIdToken"];
        if (idToken) {
          delete $window.sessionStorage["trimbleIdToken"];
          pcmtidLoginService.logOutOfTrimbleIdentity(idToken);
          // $location.url("/tid/logout");
        }
        else{
        $window.location.href = "";
        }
      });
    }
    }

    function showChangePassword() {
      vm.isOpen = false;
      alkModalService.show({
        size: "md",
        template: require("../alk-forms/change-password/changePassword.html"),
        controller: "ChangePasswordController",
        controllerAs: "vm",
        backdrop: true
      });
    }
  }
})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-cloud/alkCloudMenu.directive.js